import * as React from 'react';
import MonthAndYearPicker from './MonthAndYearPicker';

interface Props {
  id?: string;
  label?: string;

  value?: {
    month: string;
    year: string;
  };

  forceHighlightErrors?: boolean;

  displayOptions?: {
    divClassName?: string;
    labelClassName?: string;
    monthSelectClassName?: string;
    yearSelectClassName?: string;
    selectClassName?: string;
  };

  validator?: (s: string) => boolean;
  onChange(value: {
    month: string;
    year: string;

    isValid: number;
  }): void;
}

export default class StartDateInput extends React.Component<Props> {

  generateYearsList = () => {
    const now = new Date();
    const thisYear = now.getFullYear();
    const thisMonth = now.getMonth();

    if (thisMonth === 0) {
      return [thisYear];
    }

    return [thisYear, thisYear + 1];
  };

  validateInNextYear = (date: { month: string, year: string }): { valid: number, failedValidationMessage?: string } => {
    const now = new Date();
    const currentYearTwoDigits = now.getFullYear() - 2000;
    const currentMonth = now.getMonth() + 1;
    
    if (date.month === '' || date.year === '') {
      return { valid: 1, failedValidationMessage: 'A date must be selected.' };
    }

    if (Number(date.month) < currentMonth && Number(date.year) <= currentYearTwoDigits) {
      
      return { valid: 2, failedValidationMessage: 'Start date must be set in the future.' };
    }

    if (Number(date.month) >= currentMonth && Number(date.year) >= currentYearTwoDigits) {
      return { valid: 0, failedValidationMessage: '' };
    }
    
    if (Number(date.month) > currentMonth && Number(date.year) > currentYearTwoDigits) {
      return { valid: 3, failedValidationMessage: 'Start date must be within one year.' };
    }

    return { valid: 0, failedValidationMessage: '' };
  }

  hideErrorMessageLabel = (valid: boolean) => {
    return valid ? '' : 'Start date must be set and be a future date.';
  }

  render() {

    return (
      <>
        <MonthAndYearPicker
          title={this.props.label || 'Start Date'}
          showMonthName={true}
          value={{
            month: this.props.value ? this.props.value.month : '',
            year: this.props.value ? this.props.value.year : '',
          }}
          displayOptions={this.props.displayOptions}
          validation={{
            validator: this.validateInNextYear,
            forceHighlightErrors: this.props.forceHighlightErrors,
          }}
          years={this.generateYearsList()}

          dateChanged={(date) => {

            const validationResult = this.validateInNextYear(date);

            this.props.onChange({
              month: date.month,
              year: date.year.toString(),
              isValid: validationResult.valid,
            });
          }}
        />
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/StartDateInput.tsx